import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/containers/accordion.containers';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';

export default function AdminLevelOneBasicInfoComponent({
    handleInnerFormChange,
    selectedCategory,
}: any) {
    return (
        <>
            <AccordionContainer
                headerTitle="New Service Category Group"
                expandedPanel="userInfo"
                child={
                    <div className="grid md:grid-cols-2 gap-4">

                        <InputContainer
                            label="Group Code"
                            name="Code"
                            type="text"
                            value={selectedCategory?.Code}
                            isDisabled={!!selectedCategory?.GlobalAdminLayer1Id}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Code'
                                );
                            }}
                        />

                        <InputContainer
                            label="Group Name"
                            name="Name"
                            type="text"
                            value={selectedCategory?.Name}
                            isDisabled={!!selectedCategory?.GlobalAdminLayer1Id}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Name'
                                );
                            }}
                        />
                          <div className="md:col-span-2">
                            <InputContainer
                                label="Label"
                                name="Label"
                                type="text"
                                value={selectedCategory?.Label}
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Label'
                                    );
                                }}
                            />
                        </div>

                        <div className="md:col-span-2">
                            <InputContainer
                                label="Description"
                                name="Description"
                                type="text"
                                value={selectedCategory?.Description}
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Description'
                                    );
                                }}
                            />
                        </div>


                    </div>
                }
            />
        </>
    );
}